import React, { useEffect, useRef } from 'react';
import './Atmosphere.css';

export default function Atmosphere({ theme, children }) {
  const background = useRef(null);
  useEffect(() => {
    const layer = background.current;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;
    const paint = () => {
      frame = 0;
      const speed = window.innerWidth <= 700 ? 0.4 : 0.65;
      layer.style.setProperty('--ambient-offset', `${reduced.matches ? 0 : Math.max(0, window.scrollY) * speed}px`);
    };
    const schedule = () => { if (!frame) frame = window.requestAnimationFrame(paint); };
    paint();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    reduced.addEventListener('change', schedule);
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      reduced.removeEventListener('change', schedule);
    };
  }, [theme]);
  return (
    <div className={`sr-atmosphere sr-atmosphere--${theme}`}>
      <div ref={background} className="sr-atmosphere-background" aria-hidden="true" />
      {children}
    </div>
  );
}
